import InfoIconStyled from '../../../../components/InfoIcon';
import {
  IconInfoDimensions as InfoIconDimensions,
  IconInfoMap as InfoIconLocation,
  IconInfoNetwork as InfoIconNetwork,
  IconInfoNumber as InfoIconNumber,
} from '../../../../core';
import { ReactComponent as CheckboxCheckedIcon } from '../../../../images/icons/checkbox-checked.svg';
import { ReactComponent as CheckboxIcon } from '../../../../images/icons/checkbox.svg';

import { filtertMocks } from './filtertMocks';

export const stepsMocks = [
  {
    id: 1,
    title: 'What is the primary purpose of data visualization?',
    key: 'purpose',
    options: [
      {
        key: 'purpose_comp',
        text: 'Comparison',
        icon: <CheckboxIcon />,
        tooltipContent: filtertMocks[0],
      },
      {
        key: 'purpose_corr',
        text: 'Correlation',
        icon: <CheckboxIcon />,
        tooltipContent: filtertMocks[1],
      },
      {
        key: 'purpose_dist',
        text: 'Distribution',
        icon: <CheckboxIcon />,
        tooltipContent: filtertMocks[2],
      },
      {
        key: 'purpose_prop',
        text: 'Proportion',
        icon: <CheckboxIcon />,
        tooltipContent: filtertMocks[3],
      },
      {
        key: 'purpose_trend',
        text: 'Trend',
        icon: <CheckboxCheckedIcon />,
        tooltipContent: filtertMocks[4],
      },
    ],
  },
  {
    id: 2,
    title: (
      <div>
        How many dimensions
        <InfoIconStyled className="info">
          <InfoIconDimensions data-tooltip-id="tooltip-dimensions" />
        </InfoIconStyled>
        <br />
        and numerical variables
        <InfoIconStyled className="info">
          <InfoIconNumber data-tooltip-id="tooltip-numeric" />
        </InfoIconStyled>
        do you need to display?
      </div>
    ),
    key: 'dimensions',
    options: [
      {
        key: 'dimensions_1d1n',
        text: 'One dimension & one numeric variable',
        icon: <CheckboxIcon />,
        tooltipContent: filtertMocks[5],
      },
      {
        key: 'dimensions_1dmn',
        text: 'One dimension & several numeric variables',
        icon: <CheckboxIcon />,
        tooltipContent: filtertMocks[6],
      },
      {
        key: 'dimensions_md1n',
        text: 'Several dimensions & one numeric variable',
        icon: <CheckboxIcon />,
        tooltipContent: filtertMocks[7],
      },
    ],
  },
  {
    id: 3,
    title: (
      <div>
        Is the dimension related to location
        <InfoIconStyled className="info">
          <InfoIconLocation data-tooltip-id="tooltip-location" />
        </InfoIconStyled>
        ?
      </div>
    ),
    key: 'location',
    options: [
      { key: 'location_yes', text: 'Yes', icon: <CheckboxIcon />, tooltipContent: filtertMocks[8] },
      { key: 'location_no', text: 'No', icon: <CheckboxIcon />, tooltipContent: filtertMocks[9] },
    ],
  },
  {
    id: 4,
    title: (
      <div>
        Do any of the dimensions have more than 12 subdimensions
        <InfoIconStyled className="info">
          <InfoIconNetwork data-tooltip-id="tooltip-subdimensions" />
        </InfoIconStyled>
        ?
      </div>
    ),
    key: 'moreThan12',
    options: [
      {
        key: 'moreThan12_yes',
        text: 'Yes',
        icon: <CheckboxIcon />,
        tooltipContent: filtertMocks[10],
      },
      {
        key: 'moreThan12_no',
        text: 'No',
        icon: <CheckboxIcon />,
        tooltipContent: filtertMocks[11],
      },
    ],
  },
];
